import { render, staticRenderFns } from "./Session.vue?vue&type=template&id=0bfb188d&"
import script from "./Session.vue?vue&type=script&lang=ts&"
export * from "./Session.vue?vue&type=script&lang=ts&"
import style0 from "./Session.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports